import { commandDefinition, optionsDefinition } from "../../Commons/Options/CommandBasedOptionsParser";
import { CommonOptions } from "../CommonOptions/CommonOptions";
import { devModeOption, logVerbosityOption } from "../CommonOptions/CommonOptionDefintions";

export interface RenameFilesOptions extends CommonOptions {
    formGlobs: string[];
}

const localServerOptionsDefinition = optionsDefinition(
    {
        alias: "g",
        name: "gfvs",
        defaultValue: { formGlobs: [] },
        parse: (input: string[]) => ({ formGlobs: input }),
        defaultOption: true,
        multiple: true,
        description: "Одна или несколько GFV или GFV-масок для обновления.",
    },
    devModeOption,
    logVerbosityOption
);

export const renameFilesCommandDefinition = commandDefinition<"rename", RenameFilesOptions>(
    "rename",
    "rename",
    localServerOptionsDefinition,
    {
        description:
            "Обновление имен файлов *.rng.xml в *.maxSubversion.rng.xml, где maxSubversion берется из presentations.json.",
    }
);
